module.exports = __webpack_public_path__ + "img/racecourse-greyville-turf-1700.cec3617d.svg";